<template>
  <div id="app">
    <main class="segment flex flex-col justify-between">
      <PrtHeader />

      <main class="flex ">
        <PrtSidebar :items="items" v-if="items" />
        <div class="mx-auto  flex-grow h-full  justify-start mh-100 w-5/6 ">
          <!-- {{ items }} -->
          <router-view />
        </div>
      </main>
      <PrtFooter />
    </main>
  </div>
</template>

<style lang="scss"></style>

<script>
import PrtFooter from '@/components/global/PrtFooter/PrtFooter.vue'
import PrtHeader from '@/components/global/PrtHeader/PrtHeader.vue'
import PrtSidebar from '@/components/global/PrtSidebar/PrtSidebar.vue'

import gql from 'graphql-tag'
import getItems from '@/apollo/queries/getItems.gql'
import getCasesPL from '@/apollo/queries/getCasesPL.gql'
import getAllRegionsPL from '@/apollo/queries/getAllRegionsPL.gql'

export default {
  components: { PrtHeader, PrtFooter, PrtSidebar },
  data() {
    return {
      items: null
    }
  },
  mounted() {
    // this.getData()

    this.getProducts()
  },
  methods: {
    async getProducts() {
      const { data, error } = await this.$apollo.query({
        $loadingKey: 'loading',
        query: getAllRegionsPL,
        variables: {}
      })

      this.items = data.regionsPL
      this.$root.$emit('itemsPL', data.regionsPL)
      // window.localStorage.casesPL = this.items
    }
  }
}
</script>

<style lang="scss">
.float-btn {
  top: 6rem;
  right: 2rem;
}
.mh-100 {
  min-height: calc(100vh - 8rem);
}
.segment {
  min-height: 100vh;
}
</style>
